import { writable } from "svelte/store";

export interface ProvipaySuspension {
  distributor_id: number;
  reason_for_suspension: string;
  distributor: {
    name: string;
  };
  suspended_at: string;
}

export interface SuspensionStore {
  suspensions: ProvipaySuspension[];
  loaded: boolean;
  failed: boolean;
}

const defaultSuspensionStore = {
  suspensions: [],
  loaded: false,
  failed: false,
};

export const SuspensionStore = writable<SuspensionStore>(defaultSuspensionStore);
